import { useQueryClient, useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getAuthTokensKey, getNetworkKey } from '../../utils/keys';
export const useNetwork = (options) => {
    const queryClient = useQueryClient();
    const { useQueryOptions, fields = 'default' } = options || {};
    const { client } = useTribeClient();
    const networkKey = getNetworkKey();
    const authTokenKey = getAuthTokensKey();
    return useQuery(networkKey, () => client.network.get(fields), {
        initialData: () => {
            var _a;
            return (_a = queryClient.getQueryData(authTokenKey)) === null || _a === void 0 ? void 0 : _a.network;
        },
        ...useQueryOptions,
    });
};
//# sourceMappingURL=useNetwork.js.map